import { TooltipDescription } from './layout-primitives';
import { TooltipTitle } from './layout-primitives';
import { TooltipTextContent } from './layout-primitives';
import { tooltipActionsRow } from './tooltip.css';

export const defaultTooltipContentRender = ({
  title,
  description,
  action,
}: {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}) => (
  <TooltipTextContent>
    {title && <TooltipTitle>{title}</TooltipTitle>}
    {description && <TooltipDescription>{description}</TooltipDescription>}
    {action && <div className={tooltipActionsRow}>{action}</div>}
  </TooltipTextContent>
);
